import type { HTMLAttributes } from 'react'
import { cn } from '~/lib/utils'

/** 상태 색 의미는 두 표면(엔드유저/어드민)에서 동일하게 쓴다. */
export type BadgeTone =
    | 'accent'
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
    | 'neutral'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
    tone?: BadgeTone
}

const TONE_CLASSES: Record<BadgeTone, string> = {
    accent: 'bg-accent text-accent-foreground',
    success: 'bg-success-subtle text-success',
    warning: 'bg-warning-subtle text-warning',
    danger: 'bg-point-subtle text-point',
    info: 'bg-info-subtle text-info',
    neutral: 'bg-muted text-muted-foreground',
}

/** 작은 상태 배지. */
export function Badge({ className, tone = 'neutral', ...props }: BadgeProps) {
    return (
        <span
            data-slot='badge'
            className={cn(
                'inline-flex items-center rounded px-2 py-0.5 text-xs font-medium',
                TONE_CLASSES[tone],
                className
            )}
            {...props}
        />
    )
}
